// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════
   Custom State Select
   — clean trigger + searchable dropdown
══════════════════════════════════════════ */

.custom-state-select-container {
  position: relative;
  width: 100%;
}

/* ── Trigger button ── */
.custom-state-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 44px;
  border: 1px solid #e2e8f0;
  border-radius: 30px;
  padding: 0 14px;
  background: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
  cursor: pointer;
  outline: none;
  box-sizing: border-box;
  font-size: 14px;
  text-align: left;
}

.custom-state-select-trigger:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.custom-state-select-trigger.active,
.custom-state-select-trigger:focus-visible {
  border-color: #94a3b8;
  box-shadow: 0 0 0 1px #94a3b8;
  background-color: #ffffff;
}

.custom-state-select-trigger:disabled {
  background: #f1f5f9;
  cursor: not-allowed;
  border-color: #e2e8f0;
  color: #94a3b8;
}

/* Placeholder text */
.css-val-placeholder {
  color: #94a3b8;
}

/* Selected value text */
.css-val-selected {
  color: #0f172a;
  font-weight: 500;
}

/* Chevron */
.css-chevron {
  width: 16px;
  height: 16px;
  color: #94a3b8;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}
.css-chevron--open {
  transform: rotate(180deg);
}

/* ── Dropdown panel ── */
.custom-state-select-dropdown {
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow:
    0 16px 40px -8px rgba(15, 23, 42, 0.14),
    0 4px 10px -2px rgba(15, 23, 42, 0.07);
  z-index: 9999;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: css-dropdown-in 0.14s cubic-bezier(0.22,1,0.36,1);
}

@keyframes css-dropdown-in {
  from { opacity: 0; transform: translateY(-6px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0)    scale(1); }
}

/* ── Search bar ── */
.custom-state-search-wrapper {
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;
}

.css-search-icon {
  color: #94a3b8;
  flex-shrink: 0;
}

.custom-state-search-input {
  flex: 1;
  height: 34px;
  padding: 0 10px;
  font-size: 13px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  outline: none;
  background: #f8fafc;
  color: #334155;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.custom-state-search-input:focus {
  border-color: #2a71ff;
  background: #ffffff;
  box-shadow: 0 0 0 2px rgba(42,113,255,0.10);
}
.custom-state-search-input::placeholder {
  color: #94a3b8;
}

/* ── Options list ── */
.custom-state-options-list {
  list-style: none;
  margin: 0;
  padding: 4px 0;
  max-height: 200px;
  overflow-y: auto;
}

/* Slim scrollbar */
.custom-state-options-list::-webkit-scrollbar { width: 4px; }
.custom-state-options-list::-webkit-scrollbar-track { background: transparent; }
.custom-state-options-list::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }
.custom-state-options-list::-webkit-scrollbar-thumb:hover { background: #94a3b8; }

/* ── Option row ── */
.custom-state-option-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 13px;
  color: #334155;
  transition: background-color 0.1s ease;
}
.custom-state-option-item:hover {
  background-color: #f1f5f9;
}
.custom-state-option-item.state-selected {
  background-color: #f0f7ff;
  color: #2a71ff;
  font-weight: 500;
}

/* Checkmark */
.css-check-icon {
  flex-shrink: 0;
}

/* No results */
.custom-state-no-options {
  padding: 12px;
  font-size: 13px;
  color: #64748b;
  text-align: center;
}

/* ── Dark mode ── */
.dark .custom-state-select-trigger {
  background-color: #1e293b;
  border-color: #334155;
  color: #f1f5f9;
}
.dark .custom-state-select-trigger:hover {
  background-color: #253347;
}
.dark .css-val-selected { color: #f1f5f9; }
.dark .custom-state-select-dropdown {
  background-color: #1e293b;
  border-color: #334155;
  box-shadow: 0 16px 40px -8px rgba(0,0,0,0.4);
}
.dark .custom-state-search-wrapper { border-color: #334155; background: #1e293b; }
.dark .custom-state-search-input   { background: #0f172a; border-color: #334155; color: #e2e8f0; }
.dark .custom-state-option-item         { color: #cbd5e1; }
.dark .custom-state-option-item:hover   { background: #253347; }
.dark .custom-state-option-item.state-selected { background: #1e3a5f; color: #60a5fa; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/CartAddCustomer/CustomStateSelect.css"],"names":[],"mappings":"AAAA;;;4CAG4C;;AAE5C;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,uFAAuF;EACvF,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB;;0CAEwC;EACxC,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,oCAAoC,EAAE;AAC3D;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,0DAA0D;AAC5D;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB,gDAAgD,UAAU,EAAE;AAC5D,sDAAsD,uBAAuB,EAAE;AAC/E,sDAAsD,mBAAmB,EAAE,kBAAkB,EAAE;AAC/F,4DAA4D,mBAAmB,EAAE;;AAEjF,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA,0BAA0B,cAAc,EAAE;AAC1C;EACE,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;AAC9C;AACA,qCAAqC,qBAAqB,EAAE,mBAAmB,EAAE;AACjF,qCAAqC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACjG,0CAA0C,cAAc,EAAE;AAC1D,0CAA0C,mBAAmB,EAAE;AAC/D,iDAAiD,mBAAmB,EAAE,cAAc,EAAE","sourcesContent":["/* ══════════════════════════════════════════\n   Custom State Select\n   — clean trigger + searchable dropdown\n══════════════════════════════════════════ */\n\n.custom-state-select-container {\n  position: relative;\n  width: 100%;\n}\n\n/* ── Trigger button ── */\n.custom-state-select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 44px;\n  border: 1px solid #e2e8f0;\n  border-radius: 30px;\n  padding: 0 14px;\n  background: #ffffff;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;\n  cursor: pointer;\n  outline: none;\n  box-sizing: border-box;\n  font-size: 14px;\n  text-align: left;\n}\n\n.custom-state-select-trigger:hover {\n  background-color: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.custom-state-select-trigger.active,\n.custom-state-select-trigger:focus-visible {\n  border-color: #94a3b8;\n  box-shadow: 0 0 0 1px #94a3b8;\n  background-color: #ffffff;\n}\n\n.custom-state-select-trigger:disabled {\n  background: #f1f5f9;\n  cursor: not-allowed;\n  border-color: #e2e8f0;\n  color: #94a3b8;\n}\n\n/* Placeholder text */\n.css-val-placeholder {\n  color: #94a3b8;\n}\n\n/* Selected value text */\n.css-val-selected {\n  color: #0f172a;\n  font-weight: 500;\n}\n\n/* Chevron */\n.css-chevron {\n  width: 16px;\n  height: 16px;\n  color: #94a3b8;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n.css-chevron--open {\n  transform: rotate(180deg);\n}\n\n/* ── Dropdown panel ── */\n.custom-state-select-dropdown {\n  position: absolute;\n  top: calc(100% + 5px);\n  left: 0;\n  width: 100%;\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  box-shadow:\n    0 16px 40px -8px rgba(15, 23, 42, 0.14),\n    0 4px 10px -2px rgba(15, 23, 42, 0.07);\n  z-index: 9999;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: css-dropdown-in 0.14s cubic-bezier(0.22,1,0.36,1);\n}\n\n@keyframes css-dropdown-in {\n  from { opacity: 0; transform: translateY(-6px) scale(0.98); }\n  to   { opacity: 1; transform: translateY(0)    scale(1); }\n}\n\n/* ── Search bar ── */\n.custom-state-search-wrapper {\n  padding: 8px 12px;\n  border-bottom: 1px solid #f1f5f9;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.css-search-icon {\n  color: #94a3b8;\n  flex-shrink: 0;\n}\n\n.custom-state-search-input {\n  flex: 1;\n  height: 34px;\n  padding: 0 10px;\n  font-size: 13px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  outline: none;\n  background: #f8fafc;\n  color: #334155;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.custom-state-search-input:focus {\n  border-color: #2a71ff;\n  background: #ffffff;\n  box-shadow: 0 0 0 2px rgba(42,113,255,0.10);\n}\n.custom-state-search-input::placeholder {\n  color: #94a3b8;\n}\n\n/* ── Options list ── */\n.custom-state-options-list {\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n/* Slim scrollbar */\n.custom-state-options-list::-webkit-scrollbar { width: 4px; }\n.custom-state-options-list::-webkit-scrollbar-track { background: transparent; }\n.custom-state-options-list::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }\n.custom-state-options-list::-webkit-scrollbar-thumb:hover { background: #94a3b8; }\n\n/* ── Option row ── */\n.custom-state-option-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #334155;\n  transition: background-color 0.1s ease;\n}\n.custom-state-option-item:hover {\n  background-color: #f1f5f9;\n}\n.custom-state-option-item.state-selected {\n  background-color: #f0f7ff;\n  color: #2a71ff;\n  font-weight: 500;\n}\n\n/* Checkmark */\n.css-check-icon {\n  flex-shrink: 0;\n}\n\n/* No results */\n.custom-state-no-options {\n  padding: 12px;\n  font-size: 13px;\n  color: #64748b;\n  text-align: center;\n}\n\n/* ── Dark mode ── */\n.dark .custom-state-select-trigger {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n.dark .custom-state-select-trigger:hover {\n  background-color: #253347;\n}\n.dark .css-val-selected { color: #f1f5f9; }\n.dark .custom-state-select-dropdown {\n  background-color: #1e293b;\n  border-color: #334155;\n  box-shadow: 0 16px 40px -8px rgba(0,0,0,0.4);\n}\n.dark .custom-state-search-wrapper { border-color: #334155; background: #1e293b; }\n.dark .custom-state-search-input   { background: #0f172a; border-color: #334155; color: #e2e8f0; }\n.dark .custom-state-option-item         { color: #cbd5e1; }\n.dark .custom-state-option-item:hover   { background: #253347; }\n.dark .custom-state-option-item.state-selected { background: #1e3a5f; color: #60a5fa; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
